import React from 'react';
import { Link } from 'react-router-dom';
import { Star, MapPin, Settings } from 'lucide-react';
import { usePagesStatus } from '../hooks/usePagesStatus';

const Footer = () => {
  const { status: pagesStatus, loading: pagesLoading } = usePagesStatus();

  const visible = (path) => {
    if (['/'].includes(path)) return true;
    if (pagesLoading || !pagesStatus) return true;
    return pagesStatus[path.slice(1)] !== false;
  };

  return (
    <footer className="py-12 border-t border-white/5 bg-obsidian">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-gold flex items-center justify-center">
                <Star className="w-4 h-4 text-obsidian" />
              </div>
              <span className="font-syne font-bold text-white">STERED AN NOZ</span>
            </div>
            <p className="text-sm text-white/40">
              Les Étoiles de la Nuit<br />
              Awards de la musique bretonne
            </p>
          </div>
          
          {/* Navigation */}
          <div>
            <h4 className="font-syne font-bold text-white mb-4 text-sm">Navigation</h4>
            <ul className="space-y-2 text-sm text-white/50">
              <li><Link to="/" className="hover:text-gold transition-colors">Accueil</Link></li>
              {visible('/categories') && (
                <li><Link to="/categories" className="hover:text-gold transition-colors">Catégories</Link></li>
              )}
            </ul>
          </div>
          
          {/* Participer */}
          <div>
            <h4 className="font-syne font-bold text-white mb-4 text-sm">Participer</h4>
            <ul className="space-y-2 text-sm text-white/50">
              {visible('/proposer') && (
                <li><Link to="/proposer" className="hover:text-gold transition-colors">Proposer</Link></li>
              )}
              {visible('/voter') && (
                <li><Link to="/voter" className="hover:text-gold transition-colors">Voter</Link></li>
              )}
              {visible('/gala') && (
                <li><Link to="/gala" className="hover:text-gold transition-colors">Le Gala</Link></li>
              )}
              {visible('/resultats') && (
                <li><Link to="/resultats" className="hover:text-gold transition-colors">Résultats</Link></li>
              )}
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="font-syne font-bold text-white mb-4 text-sm">Plus</h4>
            <ul className="space-y-2 text-sm text-white/50">
              {visible('/actualites') && (
                <li><Link to="/actualites" className="hover:text-gold transition-colors">Actualités</Link></li>
              )}
              {visible('/partenaires') && (
                <li><Link to="/partenaires" className="hover:text-gold transition-colors">Partenaires</Link></li>
              )}
              <li className="flex items-center gap-2 pt-2">
                <MapPin className="w-4 h-4" />
                Lannion, Bretagne
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30">© 2026 Stered an Noz Awards. Tous droits réservés.</p>
          <div className="flex items-center gap-6 text-xs text-white/30">
            <span>Édition Inaugurale 2026</span>
            <Link 
              to="/admin" 
              className="flex items-center gap-1.5 text-white/30 hover:text-gold transition-colors"
              data-testid="admin-link"
            >
              <Settings className="w-3.5 h-3.5" />
              Administration
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
